// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\DomainSummary\DomainSummary.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { DomainSettings, DomainSettingsData, DomainSettingsOptions } from 'data/models/DomainSettings';

// DomainSummaryData is the class that DomainSummary serializes to/from
export interface DomainSummaryData {
    Id : number;
	
    DisplayableUrl : string;
    Settings : DomainSettingsData | null;
	
    HomePageSubtitle : string | null;
    HomePageTitle : string | null;
    Name : string;
    PilotAgencyIds : number[];
    Server : string;
    SupportEmail : string | null;
    TimeZone : string;
}

// DomainSummaryOptions is the class which may be passed to the DomainSummary constructor to define optional initial data values
export interface DomainSummaryOptions {
    Id : number;
	
    DisplayableUrl? : string;
    Settings? : DomainSettingsOptions | null;
	
    HomePageSubtitle? : string | null;
    HomePageTitle? : string | null;
    Name? : string;
    PilotAgencyIds? : number[];
    Server? : string;
    SupportEmail? : string | null;
    TimeZone? : string;
}

export class DomainSummary {
    public Id : DataSignal<number>;
	
    public DisplayableUrl : DataSignal<string>;
    public Settings : DataSignal<DomainSettings | null>;
	
    public HomePageSubtitle : DataSignal<string | null>;
    public HomePageTitle : DataSignal<string | null>;
    public Name : DataSignal<string>;
    public PilotAgencyIds : SDataArray<number>;
    public Server : DataSignal<string>;
    public SupportEmail : DataSignal<string | null>;
    public TimeZone : DataSignal<string>;

    constructor();
    constructor(data : DomainSummaryOptions);
    constructor(data: DomainSummaryOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.DisplayableUrl = jsonableObservable(S.value<string>(data && data.DisplayableUrl !== undefined ? data.DisplayableUrl : ''));
        this.Settings = S.value<DomainSettings | null>(null);
	    
        this.HomePageSubtitle = jsonableObservable(S.value<string | null>(data && data.HomePageSubtitle !== undefined ? data.HomePageSubtitle : null));
        this.HomePageTitle = jsonableObservable(S.value<string | null>(data && data.HomePageTitle !== undefined ? data.HomePageTitle : null));
        this.Name = jsonableObservable(S.value<string>(data && data.Name !== undefined ? data.Name : ''));
        this.PilotAgencyIds = jsonableObservable(SArray<number>(data && data.PilotAgencyIds !== undefined ? data.PilotAgencyIds : []));
        this.Server = jsonableObservable(S.value<string>(data && data.Server !== undefined ? data.Server : ''));
        this.SupportEmail = jsonableObservable(S.value<string | null>(data && data.SupportEmail !== undefined ? data.SupportEmail : null));
        this.TimeZone = jsonableObservable(S.value<string>(data && data.TimeZone !== undefined ? data.TimeZone : ''));
    }

    static key(obj : DomainSummary) {
        return obj.Id();
    }
    
    static dataKey(obj : DomainSummaryOptions) {
        return obj.Id;
    }

    static update(obj : DomainSummary, data : DomainSummaryOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
            if (data.DisplayableUrl !== undefined) obj.DisplayableUrl(data.DisplayableUrl);
	        
            if (data.HomePageSubtitle !== undefined) obj.HomePageSubtitle(data.HomePageSubtitle);
            if (data.HomePageTitle !== undefined) obj.HomePageTitle(data.HomePageTitle);
            if (data.Name !== undefined) obj.Name(data.Name);
            if (data.PilotAgencyIds !== undefined) obj.PilotAgencyIds(data.PilotAgencyIds);
            if (data.Server !== undefined) obj.Server(data.Server);
            if (data.SupportEmail !== undefined) obj.SupportEmail(data.SupportEmail);
            if (data.TimeZone !== undefined) obj.TimeZone(data.TimeZone);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/DomainSummary.ts